import type { Registry as Services } from '@ember/service';

export interface AccessFlags {
  features: string[];
  hasRates: boolean;
}

export default function createAccessFlags(
  access: Services['access'],
): AccessFlags {
  return {
    features: Array.from(access.featureFlags),
    hasRates: access.hasRates,
  };
}
